export enum EnrollmentAllowedActionsEnum {
  Confirm = 1,
  Reject = 2,
  All = 3,
}
